module.exports = __webpack_public_path__ + "img/ubi-ideal.62935726.jpg";